import fb from "../../../assets/images/landing/facebook.svg";
import twitter from "../../../assets/images/landing/twitter.svg";
import youtube from "../../../assets/images/landing/youtube.svg";
import insta from "../../../assets/images/landing/instagram.svg";
import linkedin from "../../../assets/images/landing/linkedin.svg";
import pinterest from "../../../assets/images/landing/pinterest.svg";
import Image from "../../common/Image";
import { useLanguage } from "../../LanguageProvider/LanguageProvider";

const TopHeader = () => {
  const { language, setLanguage } = useLanguage();

  const socialLinks = [
    { src: fb, url: "https://www.facebook.com/UttarakhandTourismOfficialPage" },
    // { src: twitter, url: "https://twitter.com/investuk" },
    {
      src: youtube,
      url: "https://www.youtube.com/channel//UCX7c5KGrPjG8tzna7xhro4g",
    },
    {
      src: insta,
      url: "https://www.instagram.com/uttarakhand_tourismofficial",
    },
    {
      src: linkedin,
      url: "https://www.linkedin.com/company/uttarakhand_tourismofficial",
    },
    { src: pinterest, url: "https://in.pinterest.com/utdbtourism/" },
  ];

  return (
    <div className="top-header-bg bg-transparent">
      <div className="mx-auto lg:px-32 md:px-20 px-4">
        <div className="top-header flex justify-between max-[640px]:flex-col md:flex-row pt-6 pb-3 max-[640px]:py-2 items-center">
          <div className="left-icons flex justify-between max-[640px]:mb-1 gap-3">
            {socialLinks.map((item, i) => (
              <a
                key={i}
                href={item.url || "#"}
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  src={item.src}
                  alt="social"
                  className="transition hover:-translate-y-1"
                  onClick={(e) => {
                    if (!item.url) {
                      e.preventDefault(); // block navigation if url missing
                    } else {
                      window.open(item.url, "_blank");
                    }
                  }}
                />
              </a>
            ))}
          </div>

          {/* RIGHT: Language Toggle */}
          <div className="flex items-center gap-2 rounded-[20px] bg-[#4f4f4f66] p-[15px] backdrop-blur-[10px] backdrop-saturate-[180%]">
            <span className="text-sm text-white">English</span>

            <button
              type="button"
              onClick={() => setLanguage(!language)}
              className={`relative inline-flex h-5 w-11 items-center rounded-full ${language ? "bg-btn" : "bg-gray-300"}`}
            >
              <span
                className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform
                  ${language ? "translate-x-6" : "translate-x-1"}`}
              />
            </button>

            <span className="text-sm text-white">हिंदी</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
